export default __webpack_public_path__ + "static/media/102-desktop.477eb35d.jpg";